export default {
  INIT: 'AUTH/PASSWORD_RESET/INIT',
  COMPLETE: 'AUTH/PASSWORD_RESET/COMPLETE',
  FAILURE: 'AUTH/PASSWORD_RESET/FAILURE'
}
